export const getHref = () => {
  return window.location.href || null;
};
export const getIsQaFromDom = () => {
  const hubspot = window.hubspot;
  return hubspot && hubspot.utils && hubspot.utils.isQA && hubspot.utils.isQA();
};